import request from '@/router/axios'

export function fetchCoursewareGroupList (params) {
  return request({
    url: '/course/admin/courseware/group/list',
    method: 'get',
    params
  })
}

export function addCoursewareGroup (obj) {
  return request({
    url: '/course/admin/courseware/group',
    method: 'post',
    data: obj
  })
}
  
export function editCoursewareGroup (obj) {
  return request({
    url: `/course/admin/courseware/group/${obj.id}`,
    method: 'put',
    data: obj
  })
}

export function removeCoursewareGroupById(id) {
  return request({
    url: `/course/admin/courseware/group/${id}`,
    method: 'delete'
  })
}

export function fetchCoursewareList (params) {
  return request({
    url: '/course/admin/courseware/page',
    method: 'get',
    params
  })
}

export function addCourseware (obj) {
  return request({
    url: '/course/admin/courseware',
    method: 'post',
    data: obj
  })
}

export function getCoursewareById (id) {
  return request({
    url: `/course/admin/courseware/${id}`,
    method: 'get'
  })
}

export function editCourseware (obj) {
  return request({
    url: `/course/admin/courseware/${obj.id}`,
    method: 'put',
    data: obj
  })
}

export function removeCoursewareById(id) {
  return request({
    url: `/course/admin/courseware/${id}`,
    method: 'delete'
  })
}

export function fetchCourseGroupList (params) {
  return request({
    url: '/course/admin/course/group/list',
    method: 'get',
    params
  })
}

export function addCourseGroup (obj) {
  return request({
    url: '/course/admin/course/group',
    method: 'post',
    data: obj
  })
}
  
export function editCourseGroup (obj) {
  return request({
    url: `/course/admin/course/group/${obj.id}`,
    method: 'put',
    data: obj
  })
}

export function removeCourseGroupById(id) {
  return request({
    url: `/course/admin/course/group/${id}`,
    method: 'delete'
  })
}

export function updateCourseGroupTopStatus(id, params) {
  return request({
    url: `/course/admin/course/group/top/${id}`,
    method: 'put',
    params,
  });
}

export function fetchCourseList (params) {
  return request({
    url: '/course/admin/course/page',
    method: 'get',
    params
  })
}

export function removeCourseById(id) {
  return request({
    url: `/course/admin/course/${id}`,
    method: 'delete'
  })
}

export function changeCourseStatus(id, params) {
  return request({
    url: `/course/admin/course/${id}`,
    method: 'POST',
    params,
  })
}

export function getEnrollScopeList() {
  return request({
    url: '/admin/admin/member/organization-tag/all',
    method: 'get',
  })
}

export function getCourseById (id) {
  return request({
    url: `/course/admin/course/${id}`,
    method: 'get'
  })
}

export function createCourse(params) {
  return request({
    url: '/course/admin/course',
    method: 'POST',
    data: params
  })
}

export function editCourse(params) {
  return request({
    url: `/course/admin/course/${params.id}`,
    method: 'PUT',
    data: params
  })
}

export function addCourseChapter(params) {
  return request({
    url: '/course/admin/chapter',
    method: 'post',
    data: params
  })
}

export function editCourseChapter(params) {
  return request({
    url: `/course/admin/chapter/${params.id}`,
    method: 'put',
    data: params
  })
}

export function addCourseCourseware(params) {
  return request({
    url: '/course/admin/course/courseware',
    method: 'post',
    data: params
  })
}

export function editCourseCourseware(params) {
  return request({
    url: `/course/admin/course/courseware/${params.id}`,
    method: 'put',
    data: params
  })
}

export function removeCourseChapterById(id) {
  return request({
    url: `/course/admin/chapter/${id}`,
    method: 'delete'
  })
}

export function sortCourseChapter(params) {
  return request({
    url: '/course/admin/chapter/sort',
    method: 'post',
    data: params
  })
}

export function sortCourseware(params) {
  return request({
    url: '/course/admin/course/courseware/sort',
    method: 'post',
    data: params
  })
}

export function removeCourseCoursewareById(id) {
  return request({
    url: `/course/admin/course/courseware/${id}`,
    method: 'delete'
  })
}

export function updateCourseTopStatus(id, params) {
  return request({
    url: `/course/admin/course/top/${id}`,
    method: 'put',
    params,
  });
}

export function fetchCourseCommentList (params) {
  return request({
    url: '/course/admin/comments/page',
    method: 'get',
    params: params
  })
}

export function updateCommentStatus (id, data) {
  return request({
    url: `/course/admin/comments/${id}`,
    method: 'put',
    headers: {
      'Content-Type': 'application/json'
    },
    data
  })
}

export function fetchCourseEnrollmentMemberList (params) {
  return request({
    url: '/course/admin/member/page',
    method: 'get',
    params: params
  })
}

export function exportEnrollmentMember (params) {
  return request({
    url: '/course/admin/member/export',
    method: 'get',
    params: params
  })
}

export function fetchCoursewareMemberEachTimeList (params) {
  return request({
    url: '/course/admin/member/each-time/page',
    method: 'get',
    params: params
  })
}

export function getCourseCoursewareById (id) {
  return request({
    url: `/course/admin/course/courseware/${id}`,
    method: 'get'
  })
}

export function fetchLearningProcessList (params) {
  return request({
    url: '/course/admin/course/courseware/member/process/page',
    method: 'get',
    params: params
  })
}

export function exportLearningProcess (params) {
  return request({
    url: '/course/admin/course/courseware/member/export/learning-process',
    method: 'get',
    params: params
  })
}

export function fetchCourseCoursewareFavoriteList (params) {
  return request({
    url: `/course/admin/course/courseware/member/favorite/list`,
    method: 'get',
    params: params
  })
}

export function fetchCoursewarePostList (params) {
  return request({
    url: `/course/admin/course/courseware/post`,
    method: 'get',
    params: params
  })
}

export function getCoursewarePost (id) {
  return request({
    url: `/course/admin/course/courseware/post/${id}`,
    method: 'get',
  })
}

export function fetchCoursewareCommentLikeList (params) {
  return request({
    url: '/course/admin/course/courseware/like/comment/page',
    method: 'get',
    params: params
  })
}

export function updateCoursewarePostBanStatus (params) {
  return request({
    url: '/course/admin/course/courseware/post/ban-status',
    method: 'post',
    data: params
  })
}

export function getCourseMiniProgramCode(id) {
  return request({
    url: `/course/admin/course/mini-program-code/${id}`,
    method: 'GET',
  })
}

export function relatedQuestionnaireId(id, params) {
  return request({
    url: `/course/admin/course/related/questionnaire-id/${id}`,
    method: 'post',
    params,
  });
}

export function addCoursewareFileTemp (params) {
  return request({
    url: '/course/admin/courseware/file-temp',
    method: 'post',
    data: params
  })
}